import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import TemplateFooter from "../components/Template/TemplateFooter";
import TemplateHeader from "../components/Template/TemplateHeader";
import TemplateSiteTitle from "../components/Template/TemplateSiteTitle";
import StatesSection from "../components/Sections/StatesSection";
import CountiesSection from "../components/Sections/CountiesSection";
import SummarySection from "../components/Sections/SummarySection";

import * as actions from '../services/actions';
import * as selectors from '../services/selectors';

import './App.css';

import '../components/Template/OfficialNotice.css';
import OfficialNotice from '../components/Template/OfficialNotice';

export class App extends Component {

  static propTypes = {
    loading: PropTypes.bool,
    displayType: PropTypes.string,
    summaryType: PropTypes.string,
    selectedCost: PropTypes.string,
    selectedStateFips: PropTypes.number,
    comparisonStateFips: PropTypes.number,
    selectedCountyFips: PropTypes.number,
    comparisonCountyFips: PropTypes.number,
    selectedState: PropTypes.object,
    comparisonState: PropTypes.object,
    selectedCounty: PropTypes.object,
    comparisonCounty: PropTypes.object,
    nationalData: PropTypes.array,
    statesData: PropTypes.array,
    countiesData: PropTypes.array,
    exportStatesData: PropTypes.func,
    exportStatesImage: PropTypes.func,
    exportStatesVector: PropTypes.func,
    exportCountiesData: PropTypes.func,
    exportCountiesImage: PropTypes.func,
    exportCountiesVector: PropTypes.func,
    exportSummaryData: PropTypes.func,
    requestNationalData: PropTypes.func,
    requestStatesData: PropTypes.func,
    requestCountiesData: PropTypes.func,
    setSelectedStateFips: PropTypes.func,
    setComparisonStateFips: PropTypes.func,
    setSelectedCountyFips: PropTypes.func,
    setComparisonCountyFips: PropTypes.func,
    setFormSelections: PropTypes.func
  }

  componentDidMount() {
    this.props.requestNationalData()
    this.props.requestStatesData()
  }

  render() {
    return (
      <div className="App">

        <div id="skipmenu">
          <a className="skippy sr-only-focusable" href="#state-summary">Skip directly to site content</a>
        </div>

        <OfficialNotice />

        <TemplateHeader/>

        <main>
          
          <TemplateSiteTitle/>

          <StatesSection
            loading={this.props.loading}
            selectedState={this.props.selectedState}
            comparisonState={this.props.comparisonState}
            selectedCounty={this.props.selectedCounty}
            comparisonCounty={this.props.comparisonCounty}
            nationalData={this.props.nationalData}
            statesData={this.props.statesData}
            countiesData={this.props.countiesData}
            summaryType={this.props.summaryType}
            displayType={this.props.displayType}
            selectedCost={this.props.selectedCost}
            selectedStateFips={this.props.selectedStateFips}
            comparisonStateFips={this.props.comparisonStateFips}
            selectedCountyFips={this.props.selectedCountyFips}
            comparisonCountyFips={this.props.comparisonCountyFips}
            onExportData={this.props.exportStatesData}
            onExportImage={this.props.exportStatesImage}
            onExportVector={this.props.exportStatesVector}
            onSelectedStateChange={this.props.setSelectedStateFips}
            onComparisonStateChange={this.props.setComparisonStateFips}
            onUpdateSelections={this.props.setFormSelections}
          />

          <CountiesSection
            loading={this.props.loading}
            selectedState={this.props.selectedState}
            comparisonState={this.props.comparisonState}
            selectedCounty={this.props.selectedCounty}
            comparisonCounty={this.props.comparisonCounty}
            nationalData={this.props.nationalData}
            statesData={this.props.statesData}
            countiesData={this.props.countiesData}
            summaryType={this.props.summaryType}
            displayType={this.props.displayType}
            selectedCost={this.props.selectedCost}
            selectedStateFips={this.props.selectedStateFips}
            comparisonStateFips={this.props.comparisonStateFips}
            selectedCountyFips={this.props.selectedCountyFips}
            comparisonCountyFips={this.props.comparisonCountyFips}
            onExportData={this.props.exportCountiesData}
            onExportImage={this.props.exportCountiesImage}
            onExportVector={this.props.exportCountiesVector}
            onSelectedStateChange={this.props.setSelectedStateFips}
            onSelectedCountyChange={this.props.setSelectedCountyFips}
            onComparisonCountyChange={this.props.setComparisonCountyFips}
            onUpdateSelections={this.props.setFormSelections}
          />

          <SummarySection
            loading={this.props.loading}
            selectedState={this.props.selectedState}
            comparisonState={this.props.comparisonState}
            selectedCounty={this.props.selectedCounty}
            comparisonCounty={this.props.comparisonCounty}
            nationalData={this.props.nationalData}
            statesData={this.props.statesData}
            countiesData={this.props.countiesData}
            summaryType={this.props.summaryType}
            displayType={this.props.displayType}
            selectedCost={this.props.selectedCost}
            selectedStateFips={this.props.selectedStateFips}
            comparisonStateFips={this.props.comparisonStateFips}
            selectedCountyFips={this.props.selectedCountyFips}
            comparisonCountyFips={this.props.comparisonCountyFips}
            onExportData={this.props.exportSummaryData}
            onUpdateSelections={this.props.setFormSelections}
          />

        </main>
        
        <TemplateFooter/>

      </div>
    );
  }
}

const mapStoreToProps = store => ({
  loading: selectors.isLoading(store),
  displayType: selectors.getDisplayType(store),
  summaryType: selectors.getSummaryType(store),
  selectedCost: selectors.getSelectedCost(store),
  selectedStateFips: selectors.getSelectedStateFips(store),
  comparisonStateFips: selectors.getComparisonStateFips(store),
  selectedCountyFips: selectors.getSelectedCountyFips(store),
  comparisonCountyFips: selectors.getComparisonCountyFips(store),
  selectedState: selectors.getSelectedState(store),
  comparisonState: selectors.getComparisonState(store),
  selectedCounty: selectors.getSelectedCounty(store),
  comparisonCounty: selectors.getComparisonCounty(store),
  nationalData: selectors.getNationalData(store),
  statesData: selectors.getStatesData(store),
  countiesData: selectors.getCountiesData(store)
});

const mapDispatchToProps = dispatch => ({
  requestNationalData: () => dispatch(actions.requestNationalData()),
  requestStatesData: () => dispatch(actions.requestStatesData()),
  requestCountiesData: fips => dispatch(actions.requestCountiesData(fips)),
  setSelectedStateFips: fips => dispatch(actions.updateSelectedStateFips(fips)),
  setComparisonStateFips: fips => dispatch(actions.updateComparisonStateFips(fips)),
  setSelectedCountyFips: fips => dispatch(actions.updateSelectedCountyFips(fips)),
  setComparisonCountyFips: fips => dispatch(actions.updateComparisonCountyFips(fips)),
  setFormSelections: selections => dispatch(actions.updateSelections(selections)),
  exportStatesData: () => dispatch(actions.exportStatesData()),
  exportStatesImage: () => dispatch(actions.exportStatesImage()),
  exportStatesVector: () => dispatch(actions.exportStatesVector()),
  exportCountiesData: () => dispatch(actions.exportCountiesData()),
  exportCountiesImage: () => dispatch(actions.exportCountiesImage()),
  exportCountiesVector: () => dispatch(actions.exportCountiesVector()),
  exportSummaryData: () => dispatch(actions.exportSummaryData())
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(App);
